const LOCALE_STORAGE_KEY = 'bbitbbit_locale'

export const SUPPORTED_LOCALES = [
  { code: 'ko', labelKey: 'locale.ko' },
  { code: 'en', labelKey: 'locale.en' },
  { code: 'ja', labelKey: 'locale.ja' },
]

const EXPLICIT_LOCALES = new Set(SUPPORTED_LOCALES.map((l) => l.code))

export function getStoredLocale() {
  if (typeof window === 'undefined') return null
  const stored = localStorage.getItem(LOCALE_STORAGE_KEY)
  if (stored === 'system' || EXPLICIT_LOCALES.has(stored)) return stored
  return null
}

export function setStoredLocale(preference) {
  if (typeof window === 'undefined') return
  localStorage.setItem(LOCALE_STORAGE_KEY, preference)
}

export function detectBrowserLocale() {
  if (typeof navigator === 'undefined') return 'ko'
  const lang = (navigator.language || 'ko').toLowerCase()
  if (lang.startsWith('en')) return 'en'
  if (lang.startsWith('ja')) return 'ja'
  if (lang.startsWith('ko')) return 'ko'
  return 'ko'
}

/** 실제 i18n에 적용할 locale (system이면 브라우저 기준) */
export function resolveLocale(preference = getStoredLocale()) {
  if (!preference || preference === 'system') return detectBrowserLocale()
  return EXPLICIT_LOCALES.has(preference) ? preference : 'ko'
}

export function detectInitialLocale() {
  return resolveLocale(getStoredLocale())
}
